import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/nice.png'
import _imports_1 from '@/assets/image/icon/comment.png'


const _withScopeId = n => (_pushScopeId("data-v-1a2f2e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "main-content__title" }
const _hoisted_4 = { class: "main-content__aricle" }
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "footer-user" }
const _hoisted_7 = { class: "names" }
const _hoisted_8 = { class: "footer-user__name" }
const _hoisted_9 = { class: "footer-user__time" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, "·", -1))
const _hoisted_11 = { class: "footer-options" }
const _hoisted_12 = { class: "footer-options-left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_14 = { class: "footer-options-right" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))

import { reactive } from 'vue'
import MImage from '@/components/MImage/MImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MArticle',
  props: {
  article: { type: Object },
},
  emits: ['handleClick'],
  setup(__props, { emit: emits }) {

const props = __props;




const state = reactive({
  article: props.article,
})

const handleClickItem = () => {
  emits('handleClick', state.article)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "article",
    onClick: handleClickItem
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(state.article.informationTitle), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(state.article.abstracts), 1)
      ]),
      _createVNode(MImage, {
        src: state.article.coverMapUrl
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(MImage, {
          type: "avatar",
          src: state.article.headImg
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(state.article.userName), 1),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(state.article?.pushDate
                ? state.article?.pushDate.split(' ')[0]
                : ''), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(state.article.likeCount), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", null, _toDisplayString(state.article.commentCount), 1)
        ])
      ])
    ])
  ]))
}
}

})